// extracted by mini-css-extract-plugin
export var active = "_jw-2";
export var recordingDot = "_jw-1";
export var recordingIndicator = "_jw-0";